import styled from 'styled-components';
import { FIRST, LAST, MIDDLE, PartPosition } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/utils';
import { theme } from 'styles';
import { BlueButton, Flex } from 'UI';

const CROSSLINK_OFFSET = 46;
const CROSSLINK_EXTENSION = 20;

export const StickyStrip = styled(Flex)`
  flex: 0 0 auto;
  height: 125px;
  position: fixed;
  left: var(--page-side-bar-width, 0px);
  right: 0;
  bottom: 0;
  padding: 0 30px;
  transition: left 200ms ease, right 200ms ease;
  will-change: left, right;
  box-shadow: 0 -4px 8px ${theme.color.grey85};
  background-color: ${theme.color.white};
  z-index: 889;
`;

export const EasyBasketCardWrapper = styled(Flex)<{ isAlternative?: boolean; multipleReferencesGroup?: boolean }>`
  border-radius: 15px;
  background-color: ${({ multipleReferencesGroup, isAlternative }) =>
    multipleReferencesGroup && !isAlternative && theme.color.ice_blue};
  box-shadow: ${({ isAlternative }) => !isAlternative && `0 3px 10px 0  ${theme.color.grey85}`};
  border: ${({ isAlternative }) => isAlternative && `2px dashed ${theme.color.grey75}`};
  max-height: 92px;
`;

export const ReferenceCardIndex = styled(Flex)<{ isActive?: boolean }>`
  border-radius: 4px;
  background-color: ${({ isActive }) => (isActive ? theme.color.clear_blue : theme.color.grey90)};
  cursor: pointer;
`;

export const InfoAlertWrapper = styled.div`
  width: 100%;
  height: 75px;
  padding-left: 50px;
`;

export const CrosslinkCardWrapper = styled(Flex)`
  position: relative;
  left: 10px;
`;

export const AlternativeCrosslink = styled.div<{ position?: PartPosition }>`
  width: 30px;
  height: ${({ position }) =>
    position === FIRST ? `${60 + CROSSLINK_EXTENSION}px` : `${125 + CROSSLINK_EXTENSION}px`};
  border-left: 2px solid ${theme.color.grey65};
  border-bottom: 2px solid ${theme.color.grey65};
  border-radius: 0 0 0 15px;
  position: absolute;
  bottom: ${CROSSLINK_OFFSET - CROSSLINK_EXTENSION}px;
`;

export const Crosslink = styled.div<{ position?: PartPosition; isAlternative?: boolean }>`
  position: absolute;
  width: 30px;
  border-left: 2px solid ${theme.color.grey65};

  ${({ position }) => {
    switch (position) {
      case FIRST:
        return `
            height: ${70 + CROSSLINK_EXTENSION}px;
            border-top: 2px solid ${theme.color.grey65};
            border-radius: 15px 0 0 0;
            top: ${CROSSLINK_OFFSET - CROSSLINK_EXTENSION}px;
        `;
      case MIDDLE:
        return `
            height: ${120 + 2 * CROSSLINK_EXTENSION}px;
            top: ${CROSSLINK_OFFSET}px;
            transform: translateY(-50%); /* zarovnání na střed */
        `;
      case LAST:
        return `
            height: ${70 + CROSSLINK_EXTENSION}px;
            border-bottom: 2px solid ${theme.color.grey65};
            border-radius: 0 0 0 15px;
            bottom: ${CROSSLINK_OFFSET - CROSSLINK_EXTENSION}px;
        `;
      default:
        return '';
    }
  }}
`;

export const ConnectionLink = styled.div`
  width: 30px;
  border-bottom: 2px solid ${theme.color.grey65};
  position: absolute;
  top: ${CROSSLINK_OFFSET}px;
`;

export const NarrowLink = styled.div`
  width: 30px;
  height: ${120 + 2 * CROSSLINK_EXTENSION}px;
  border-left: 2px solid ${theme.color.grey65};
  position: absolute;
  top: ${CROSSLINK_OFFSET}px;
  transform: translateY(-50%);
`;

export const IconWrapper = styled(Flex)`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: ${theme.color.grey95};
  justify-content: center;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`;

export const SelectedQuantity = styled(Flex)`
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: ${theme.color.info};
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const SBlueButton = styled(BlueButton)`
  flex: 0 0 auto;
  margin-left: auto;
`;
